var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00337791 9.98431C0.00272655 9.65111 0.118916 9.32819 0.331779 9.07162L7.47095 0.515173C7.7133 0.223945 8.06157 0.0408018 8.43913 0.00603444C8.81668 -0.0287329 9.19261 0.0877231 9.48419 0.329783C9.77578 0.571843 9.95915 0.919679 9.99396 1.29677C10.0288 1.67386 9.91217 2.04932 9.66981 2.34055L3.27312 9.98431L9.44136 17.6281C9.55996 17.7739 9.64853 17.9418 9.70198 18.122C9.75542 18.3021 9.77269 18.4911 9.75279 18.6779C9.73289 18.8648 9.67621 19.0459 9.586 19.2108C9.4958 19.3757 9.37386 19.5212 9.22718 19.6388C9.08037 19.7694 8.90814 19.8684 8.72127 19.9294C8.5344 19.9904 8.33693 20.0122 8.14123 19.9935C7.94553 19.9747 7.75581 19.9158 7.58396 19.8205C7.41211 19.7251 7.26183 19.5953 7.14255 19.4392L0.24611 10.8827C0.0668936 10.6188 -0.018569 10.3025 0.00337791 9.98431Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftPagination);
export default __webpack_public_path__ + "static/media/arrow-left-pagination.1afa48726b3ad52fc81f62b2df596028.svg";
export { ForwardRef as ReactComponent };